///<amd-module name="typeahead/client/MercuryWizardHandler" />
/// <amd-dependency path="jquery" name="$"/>
/// <reference path="../../typings/thirdparty/jquery/jquery.d.ts" />
import {ClientHandlerRegistry, IClientHandler} from "typeahead/client/ClientHandlerRegistry";
import {FormLoadedMessage} from "typeahead/core/message/FormLoadedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class MercuryWizardHandler implements IClientHandler {
    private static readonly APPLICABLE_CLIENT_IDS = [
        "Homepage",
        "AWSHomepage",
        "LXLandingPage",
        "CarsLandingPage",
        "FlightsLandingPage",
        "HotelsLandingPage",
        "PackageLandingPage",
        "RailsLandingPage",
    ];

    public isApplicable(clientId: string): boolean {
        return MercuryWizardHandler.APPLICABLE_CLIENT_IDS.indexOf(clientId) > -1;
    }

    public subscribeFormSubmitEvent(): void {
        let that = this;

        $("form").on("click", "button[type=submit]", (event) => {
            if ($(event.target).parents("form:has(input[data-provide=utypeahead])").length > 0) {
                ClientHandlerRegistry.publishSubmitClickedMessage(null, event);
            }
        });

        $("form:has(input[data-provide=utypeahead])").on("submit.typeahead", () => {
            let isFormValid = (): boolean => {
                let validationElement = $("form:has(input[data-provide=utypeahead]):visible .validation-alert");
                return validationElement.is(":hidden") || validationElement.hasClass("visuallyhidden");
            };
            setTimeout(() => {
                ClientHandlerRegistry.publishFormSubmittedMessage(isFormValid());
            }, 0);
        });
    }

    public subscribeFormLoadedEvent(): void {
        let publishFormLoadedMessage = () => {
            TypeaheadMessage.publish(
                new FormLoadedMessage(this.getTab()));
        };
        publishFormLoadedMessage(); // On Page Load
        uitk.subscribe("mercury-form-history-loaded", () => {
            publishFormLoadedMessage(); // On tab change
        });
    }

    public getTab(): string {
        return $("li.tab:visible").children("button.on").data("lob");
    }
}
